import React, { lazy, Suspense } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { selectAuthState } from "app/auth/authSlice";
import { useAppSelector } from "app/hooks";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "components/Footer/Footer";
import PageHome from "containers/PageHome/PageHome";
import { shallowEqual } from "react-redux";
import SessionSecurityWrapper from "SessionSecurityWrapper";
import HeaderContainer from "containers/HeaderContainer/HeaderContainer";

// Route-level code-splitting for non-home pages
const PageSingleTemp3Sidebar = lazy(() => import("containers/PageSingle/PageSingleTemp3Sidebar"));
const PageArchive = lazy(() => import("containers/PageArchive/PageArchive"));
const PageAuthor = lazy(() => import("containers/PageAuthor/PageAuthor"));
const PreviewBlog = lazy(() => import("containers/PageSingle/PreviewBlog"));
const PageAbout = lazy(() => import("containers/PageAbout/PageAbout"));
const PageContact = lazy(() => import("containers/PageContact/PageContact"));
const TermsConditions = lazy(() => import("containers/Terms&Conditions/TermsConditions"));
const PrivacyPolicy = lazy(() => import("containers/PrivacyPolicy/PrivacyPolicy"));
const Guidelines = lazy(() => import("containers/Guidelines/Guidelines"));
const Page404 = lazy(() => import("containers/Page404/Page404"));
const Page502 = lazy(() => import("containers/Page502/Page502"));
const PageLogin = lazy(() => import("containers/PageLogin/PageLogin"));
const PageSignUp = lazy(() => import("containers/PageSignUp/PageSignUp"));
const PageForgotPass = lazy(() => import("containers/PageForgotPass/PageForgotPass"));
const PageDashboard = lazy(() => import("containers/PageDashboard/PageDashboard"));
const VerfiyLoginPage = lazy(() => import("containers/PageLogin/VerifyLoginPage"));

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/blog/:slug", component: PageSingleTemp3Sidebar },
  { path: "/discover", exact: true, component: PageArchive },
  { path: "/author/:slug", component: PageAuthor },
  { path: "/blog-preview", exact: true, component: PreviewBlog },
  { path: "/about", exact: true, component: PageAbout },
  { path: "/contact", exact: true, component: PageContact },
  { path: "/terms-conditions", exact: true, component: TermsConditions },
  { path: "/privacy-policy", exact: true, component: PrivacyPolicy },
  { path: "/guidelines", exact: true, component: Guidelines },
  { path: "/page404", exact: true, component: Page404 },
  { path: "/page502", exact: true, component: Page502 },
  { path: "/login", exact: true, component: PageLogin },
  { path: "/signup", exact: true, component: PageSignUp },
  { path: "/forgot-pass", exact: true, component: PageForgotPass },
  { path: "/dashboard", component: PageDashboard, auth: true },
  { path: "/verification/:email", component: VerfiyLoginPage },
];

const Routes = () => {
  const { token } = useAppSelector(selectAuthState, shallowEqual);
  return (
    <BrowserRouter basename={import.meta.env.VITE_BASE_PATH || ""}>
      <HeaderContainer />
      <ScrollToTop />
      <main id="main-content" tabIndex={-1} className="outline-none focus:outline-none">
        <Suspense
          fallback={
            <div className="container py-24 flex justify-center items-center min-h-[400px]">
              <div className="w-10 h-10 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
            </div>
          }
        >
          <Switch>
              {pages.map(({ component: Component, path, exact, auth }) => {
                if (auth) {
                  return (
                    <Route
                      key={path}
                      render={(props) =>
                        token ? <SessionSecurityWrapper> <Component {...props} /> </SessionSecurityWrapper> : <Redirect to="/login" />
                      }
                      exact={!!exact}
                      path={path}
                    />
                  );
                }

                return (
                  <Route
                    key={path}
                    component={Component}
                    exact={!!exact}
                    path={path}
                  />
                );
              })}
            <Route component={Page404} />
            <Route path="/page502" component={Page502} />
          </Switch>
        </Suspense>
      </main>
      <Footer />
      {/* MEDIA */}
    </BrowserRouter>
  );
};

export default Routes;
